package com.devi3east.bashbuddy.composeApp

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.devi3east.bashbuddy.BashBuddyLocalDatabase
import com.devi3east.bashbuddy.FavoriteRecipeQueries
import com.devi3east.bashbuddy.Recipe
import com.devi3east.bashbuddy.RecipeEntityQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<BashBuddyLocalDatabase>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = BashBuddyLocalDatabaseImpl.Schema

internal fun KClass<BashBuddyLocalDatabase>.newInstance(driver: SqlDriver,
    RecipeAdapter: Recipe.Adapter): BashBuddyLocalDatabase = BashBuddyLocalDatabaseImpl(driver,
    RecipeAdapter)

private class BashBuddyLocalDatabaseImpl(
  driver: SqlDriver,
  RecipeAdapter: Recipe.Adapter,
) : SuspendingTransacterImpl(driver), BashBuddyLocalDatabase {
  override val favoriteRecipeQueries: FavoriteRecipeQueries = FavoriteRecipeQueries(driver,
      RecipeAdapter)

  override val recipeEntityQueries: RecipeEntityQueries = RecipeEntityQueries(driver, RecipeAdapter)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE FavoriteRecipe (
          |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
          |    recipe_id INTEGER UNIQUE NOT NULL,
          |    added_at TEXT NOT NULL,
          |    FOREIGN KEY (recipe_id) REFERENCES Recipe(id) ON DELETE CASCADE
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE Recipe (
          |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
          |    title TEXT NOT NULL,
          |    description TEXT NOT NULL,
          |    category TEXT NOT NULL,
          |    area TEXT NOT NULL,
          |    imageUrl TEXT NOT NULL,
          |    youtubeLink TEXT NOT NULL,
          |    ingredients TEXT NOT NULL,
          |    instructions TEXT NOT NULL,
          |    isFavorite INTEGER NOT NULL,
          |    rating INTEGER NOT NULL,
          |    duration TEXT DEFAULT '20 Mins',
          |    difficulty TEXT DEFAULT 'Easy'
          |)
          """.trimMargin(), 0).await()
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
    }
  }
}
